module.exports = __webpack_public_path__ + "static/media/avenir-black-webfont.d4d3a42a.woff";